import resource from '../../../services/purchase/requisition.js';
import requsitionList from './requsitionList'

export default {
    namespaced: true,
    modules: {
        requsitionList
    },
    actions: {
        findByID(context, payload) {
            return new Promise((resolve, reject) => {
                resource.findByID(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        create(context, payload) {
            return new Promise((resolve, reject) => {
                resource.create(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                resource.update(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        remove(context, payload){
            return new Promise((resolve, reject) => {
                resource.remove(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        }
    }
}